module.exports = __webpack_public_path__ + "static/media/quidditch.b4827f39.svg";